export default __webpack_public_path__ + "static/screen_erp_4-cb070933996be8243e74db3335168999.png";